import { SvgIconProps } from "@mui/material/SvgIcon";
import TuneIcon from "@mui/icons-material/Tune";
import React, { FunctionComponent } from "react";

export const TunesIcon: FunctionComponent<SvgIconProps> = (props) => {
	return <TuneIcon {...props} />;
};

export default TunesIcon;